/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeasureDto } from '../../models/measure-dto';

export interface GetMeasures$Params {

/**
 * The customer id
 */
  customerId: number;

/**
 * The hazard id which contains the measures
 */
  hazardId: number;
}

export function getMeasures(http: HttpClient, rootUrl: string, params: GetMeasures$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MeasureDto>>> {
  const rb = new RequestBuilder(rootUrl, getMeasures.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.query('hazardId', params.hazardId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MeasureDto>>;
    })
  );
}

getMeasures.PATH = '/customers/{customerId}/measures';
